<template>
  <div class="ev">
    <carousel :images="imgs"
              arrow="never">
      <div class="header_box">
        <div class="header_title"
             style="text-align: center;"><span>{{$t('ev.name')}}</span></div>
        <div class="header_content">{{$t('ev.nav_content')}}</div>
      </div>
    </carousel>
    <!-- 汽车厂商数字化转型 -->
    <div class="fixed_width">
      <div class="content_title">{{$t('ev.subTitle1')}}</div>
      <!-- <div class="box"
           style="width: 3.2rem">
        <div class="subtitle">{{$t('ev.part1_box1_title')}}</div>
        <div class="content fontColor_grayBlue">{{$t('ev.part1_box1_subtitle')}}</div>
        <div v-if="!mobileDevice"
             class="content fontColor_gray">{{$t('ev.part1_box1_content')}}</div>
      </div> -->
      <el-row type="flex"
              align="middle">
        <el-col :span="8">
          <div class="box"
               style="text-align: right">
            <div class="subtitle">{{$t('ev.part1_box2_title')}}</div>
            <div class="content fontColor_grayBlue">{{$t('ev.part1_box2_subtitle')}}</div>
            <div v-if="!mobileDevice"
                 class="content fontColor_gray">{{$t('ev.part1_box2_content')}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <img class="evImage1"
               src="@/assets/images/ev1.png">
        </el-col>
        <el-col :span="8">
          <div class="box"
               style="text-align: left">
            <div class="subtitle">{{$t('ev.part1_box3_title')}}</div>
            <div class="content fontColor_grayBlue">{{$t('ev.part1_box3_subtitle')}}</div>
            <div v-if="!mobileDevice"
                 class="content fontColor_gray">{{$t('ev.part1_box3_content')}}</div>
          </div>
        </el-col>
      </el-row>
      <div class="box"
           style="width: 4rem">
        <div class="subtitle">{{$t('ev.part1_box4_title')}}</div>
        <div class="content fontColor_grayBlue">{{$t('ev.part1_box4_subtitle')}}</div>
        <div v-if="!mobileDevice"
             class="content fontColor_gray">{{$t('ev.part1_box4_content')}}</div>
      </div>
    </div>
    <!-- 基于新能源汽车检测评估及电池健康度评估服务 -->
    <div style="width: 100%; background: #F9F9F9; padding: 1px 0px;">
      <div class="fixed_width">
        <div class="content_title"
             style="margin-bottom: 0.4rem">{{$t('ev.subTitle2')}}</div>
        <div class="subContent">
          <!-- <div class="content fontColor_blue">{{$t('ev.part2_subtitle')}}</div> -->
          <div class="content fontColor_gray">{{$t('ev.part2_content1')}}</div>
          <div class="content fontColor_gray">{{$t('ev.part2_content2')}}</div>
        </div>
        <img v-if="lang === 'zh'"
             class="evImage2"
             src="@/assets/images/ev2.png">
        <img v-if="lang === 'en'"
             class="evImage2"
             src="@/assets/images/ev2_en.png">
      </div>
    </div>
    <!-- 新能源汽车租赁与回购解决方案 -->
    <!-- <div class="fixed_width">
      <div class="content_title"
           style="margin-bottom: 0.4rem">{{$t('ev.subTitle3')}}</div>
      <div class="subContent"
           style="margin-bottom: 0.41rem;">
        <div class="content fontColor_gray">{{$t('ev.part3_content1')}}</div>
      </div>
      <img v-if="lang === 'zh'"
           class="evImage3"
           src="@/assets/images/ev3.png">
      <img v-if="lang === 'en'"
           class="evImage3"
           src="@/assets/images/ev3_en.png">
    </div> -->
  </div>
</template>

<script>
import Carousel from '@/components/carousel'
import headerImg from '@/assets/images/ev_header.png'

export default {
  components: {
    Carousel
  },
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      }
    },
    lang() {
      return this.$store.state.lang
    }
  },
  data() {
    return {
      imgs: [headerImg]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "../../style/header_box.scss";
@import "../../style/content_title.scss";
@import "../../style/fixed_width.scss";
.ev {
  .box {
    display: inline-block;
    max-width: 100%;
    padding: 0px 0.32rem;
    .subtitle {
      font-size: 0.18rem;
      font-weight: 500;
      color: rgba(66, 101, 135, 1);
    }
  }

  .subContent {
    display: inline-block;
    width: 8.3rem;
    max-width: 80%;
  }

  .content_title {
    max-width: 80%;
  }

  .content {
    font-size: 0.14rem;
    font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue",
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-weight: 400;
    line-height: 0.26rem;
  }
  .el-row {
    margin: 0.28rem 0rem;
  }

  .evImage1 {
    width: 4.37rem;
    max-width: 100%;
  }

  .evImage2 {
    width: 11.78rem;
    max-width: 80%;
    margin-top: 50px;
  }
  .evImage3 {
    width: 9.24rem;
    max-width: 80%;
  }

  .fontColor_grayBlue {
    color: rgba(66, 101, 135, 1);
  }
  .fontColor_blue {
    color: rgba(93, 170, 248, 1);
  }
  .fontColor_gray {
    color: rgba(156, 156, 156, 1);
  }

  @media only screen and (max-width: 750px) {
    .el-row {
      margin: 0.14rem 0rem;
    }

    .fixed_width {
      padding-bottom: 30px;
    }

    .evImage2 {
      margin-top: 25px;
    }
  }
}
</style>
